import React from "react";
import { Badge, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import ButtonBar from "../Layout/ButtonBar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavLink } from "react-router-dom";

export default function CrudBar({ selected, onDelete = () => {}, 
    disabled, 
    updateDisabled, updateDisabledTooltip,
    deleteDisabled, deleteDisabledTooltip,
    children, onFilter = () => {}, filterCount = 0 }) {

    return (
        <ButtonBar>
            {
                disabled ?
                <Button disabled size="sm" className="mr-2" variant="outline-primary">
                    <FontAwesomeIcon icon="cog" spin/> Carregando...
                </Button>
                :
                <>
                    <Button as={NavLink} size="sm" className="mr-2" to={location => `${location.pathname}/incluir`}>
                        <FontAwesomeIcon icon="fa-plus"/> Incluir
                    </Button>
                    { (!selected || updateDisabled) ?
                        updateDisabledTooltip ?
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{updateDisabledTooltip}</Tooltip>}
                        >
                            <Button disabled size="sm" className="mr-2" variant="warning">
                                <FontAwesomeIcon icon="fa-edit"/> Alterar
                            </Button>
                        </OverlayTrigger>
                        :
                        <Button disabled size="sm" className="mr-2" variant="warning">
                            <FontAwesomeIcon icon="fa-edit"/> Alterar
                        </Button>
                        :
                        <Button as={NavLink} size="sm" className="mr-2" variant="warning" to={location => `${location.pathname}/alterar/${selected && selected.id}`}>
                            <FontAwesomeIcon icon="fa-edit"/> Alterar
                        </Button>
                    }
                    { (!selected || deleteDisabled) ?
                        deleteDisabledTooltip ?
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{deleteDisabledTooltip}</Tooltip>}
                        >
                            <Button disabled size="sm" className="mr-2" variant="danger">
                                <FontAwesomeIcon icon="fa-trash"/> Excluir
                            </Button>
                        </OverlayTrigger>
                        :
                        <Button disabled size="sm" className="mr-2" variant="danger">
                            <FontAwesomeIcon icon="fa-trash"/> Excluir
                        </Button>
                        :
                        <Button as={NavLink} size="sm" className="mr-2" variant="danger" to={location => `${location.pathname}/excluir/${selected && selected.id}`} >
                            <FontAwesomeIcon icon="fa-trash"/> Excluir
                        </Button>
                    }   
                </>
            }
            <div className="flex-fill d-flex justify-content-between px-2 border-left" style={{ height: "100%"}}>
                <div>
                    {children}
                </div>
                <div>
                    <Button onClick={() => onFilter()} size="sm" className="mr-2" variant="outline-primary">
                        <FontAwesomeIcon icon="filter"/> Filtrar {(!!filterCount && filterCount > 0) && <Badge variant="primary">{filterCount}</Badge>}
                    </Button>
                    {/* <Button size="sm" className="mr-2" variant="outline-primary">
                        <FontAwesomeIcon icon="print"/> Exportar
                    </Button>
                    <Button as={NavLink} size="sm" className="mr-2" variant="outline-primary" to={location => `${location.pathname}/audit`}>
                        <FontAwesomeIcon icon="history"/> Auditoria
                    </Button> */}
                </div>
            </div>
        </ButtonBar>
    )
}